import React from 'react'
import { Typography } from '../Typography'
import { Tooltip } from '../Tooltip' // Assuming Tooltip is imported from the correct path
import type { StatCardProps } from './types'
import clsx from 'clsx'
import { InfoCircle } from '@sylveraio/untitled-ui-icons-react'

export const StatCard: React.FC<StatCardProps> = ({ data, className = '' }) => {
  return (
    <div
      className={clsx(
        'border border-default rounded-lg shadow-sm w-full bg-white',
        className,
      )}
    >
      {data.map((item, index) => (
        <div
          key={index}
          className="flex justify-start border-b px-2 py-3 last:border-b-0 border-default items-center"
        >
          <span className="px-2 font-semibold text-gray-700 w-52 flex-shrink-0 flex space-x-1 items-center">
            <Typography className="text-subtle" size="sm">
              {item.title}
            </Typography>
            {item.tooltip && (
              <Tooltip
                condensed
                supportingText={
                  typeof item.tooltip === 'string' ? item.tooltip : undefined
                }
                customContent={
                  typeof item.tooltip !== 'string' ? item.tooltip : undefined
                }
              >
                <InfoCircle className="w-4 text-subtle" />
              </Tooltip>
            )}
          </span>
          <span className="text-gray-900">
            {typeof item.value === 'object' ? (
              item.value
            ) : (
              <Typography size="sm">{item.value}</Typography>
            )}
          </span>
        </div>
      ))}
    </div>
  )
}
